import React from 'react';
import './LedProgressLine.css';

const LedProgressLine = ({ isActive }) => {
  return (
    <div className={`led-progress-container ${isActive ? 'active' : ''}`}>
      <div className="led-progress-line">
        <div className="led-progress-glow"></div>
      </div>
    </div>
  );
};

export default LedProgressLine;
